var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 512 512",
    fill: "rgb(10, 96, 48)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64C0 311.4 200.6 512 448 512h32l32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0 0 32 0 64zM16 44.8L135.8 18.2 203.4 140l-73.2 58.6-10.3 8.3 6.2 11.7c37.6 71.3 96.2 129.8 167.4 167.4l11.7 6.2 8.3-10.3L372 308.6l121.7 67.6L467.1 496H448C209.4 496 16 302.6 16 64l0 0 0-19.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a1a71e23ebc5ae91526a7301bc04d89b.svg";
export { ForwardRef as ReactComponent };